// extracted by mini-css-extract-plugin
export default {"userRequestPageContainer":"UserRequestPage_userRequestPageContainer__ADoGh","pageTitle":"UserRequestPage_pageTitle__XdQ5N"};